import {
  SecurityRoleSetCode,
  UserSecurityFormValues
} from "./UserSecurityForm";
import { SecurityRoleAssignmentsDto } from "@libs/api/gateways/plt/plt-gateway.dtos";

export const getUserSecurityInitialValues = (
  securityRoleAvailableAssignments: SecurityRoleAssignmentsDto[],
  businessRoles?: string[]
): UserSecurityFormValues => {
  const initSecurityRoles = securityRoleAvailableAssignments
    .map(s => s.securityRoleSets)
    .flat()
    ?.reduce((acc: Record<SecurityRoleSetCode, string>, sr) => {
      const assignedSecRole = sr.securityRoles.find(s => s.isAssigned);
      if (!assignedSecRole) return acc;

      return {
        ...acc,
        [sr.code]: assignedSecRole.code
      };
    }, {} as Record<SecurityRoleSetCode, string>);

  return {
    businessRoles: businessRoles ?? [],
    securityRoles: initSecurityRoles ?? {}
  };
};
